// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"header_doctrine_logo-module--wrapper--WPADd","hide":"header_doctrine_logo-module--hide--2ZvDB"};